/** Syx role IDs. Lower numbers have higher privilege. */

export const ROLES = {
  ROOT: 0,
  MANAGER: 2,
  STAFF: 3,
  ANALYTICS: 10,
} as const

export type RoleValue = typeof ROLES[keyof typeof ROLES]

export function getRoleLabel(role: number): string {
  switch (role) {
    case ROLES.ROOT:
      return 'Root'
    case ROLES.MANAGER:
      return 'Manager'
    case ROLES.STAFF:
      return 'Staff'
    case ROLES.ANALYTICS:
      return 'Analytics'
    default:
      return `Unknown (${role})`
  }
}

export function getRoleColor(role: number): string {
  switch (role) {
    case ROLES.ROOT:
      return 'error'
    case ROLES.MANAGER:
      return 'success'
    case ROLES.STAFF:
      return 'info'
    case ROLES.ANALYTICS:
      return 'warning'
    default:
      return 'grey'
  }
}

export function canCreateUser(creatorRole: number): boolean {
  return creatorRole === ROLES.ROOT
}

export function canChangeRole(editorRole: number, targetRole: number): boolean {
  return editorRole === ROLES.ROOT && targetRole !== ROLES.ROOT
}

export function canResetPassword(editorRole: number, targetRole: number): boolean {
  if (targetRole === ROLES.ROOT) return false
  if (editorRole === ROLES.ROOT) {
    return true
  }
  if (editorRole === ROLES.MANAGER) {
    return targetRole > ROLES.MANAGER
  }
  return false
}

export function getAvailableRoles(creatorRole: number): Array<{ value: number; label: string }> {
  if (creatorRole === ROLES.ROOT) {
    return [
      { value: ROLES.MANAGER, label: getRoleLabel(ROLES.MANAGER) },
      { value: ROLES.STAFF, label: getRoleLabel(ROLES.STAFF) },
      { value: ROLES.ANALYTICS, label: getRoleLabel(ROLES.ANALYTICS) },
    ]
  }
  return []
}
